<template>
  <svg :width="width" :height="height" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.6068 10.6064C4.74874 16.4644 4.74874 25.9619 10.6068 31.8199C16.4645 37.6776 25.9619 37.6776 31.82 31.8196C37.6777 25.9619 37.6777 16.4644 31.82 10.6067C25.958 4.75861 16.4687 4.75831 10.6068 10.6064ZM30.1094 30.109C25.1962 35.0221 17.2308 35.0221 12.3176 30.109C7.40449 25.1959 7.40449 17.2304 12.3176 12.3173C17.2305 7.40442 25.1962 7.40412 30.1094 12.3173C35.0144 17.2337 35.0144 25.1925 30.1094 30.109ZM21.2132 13.5912C20.5454 13.5912 20.0037 14.1329 20.0037 14.8008V20.0033L14.8015 20.003C14.3691 20.003 13.9698 20.2336 13.7536 20.6082C13.5374 20.9828 13.5374 21.4441 13.7536 21.8181C13.9698 22.1926 14.3694 22.423 14.8015 22.4233L20.0037 22.423L20.0034 27.6252C20.0058 28.2912 20.5466 28.8302 21.2129 28.8299C21.8792 28.8302 22.42 28.2912 22.4224 27.6252L22.423 22.4227L27.6253 22.423C28.2916 22.4203 28.8303 21.8798 28.83 21.2134C28.83 20.5474 28.2913 20.0063 27.6249 20.0042L22.423 20.0036L22.4233 14.8014C22.4233 14.4804 22.2963 14.1727 22.0692 13.9456C21.8422 13.7186 21.5345 13.5909 21.2132 13.5912Z" :fill="invert?color:color2"/>
  </svg>
</template>

<script>
export default {
  props: {
    invert: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 43
    },
    height: {
      type: Number,
      default: 43
    },
    color: {
      type: String,
      default: 'white'
    },
    color2: {
      type: String,
      default: 'var(--color-pri)'
    }
  }
}
</script>
